import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Wrapper from '../../components/wrapper';
import {convertPipeToBrTag} from "../../utils";
import {getComponents} from "../utilities";
import AccessoryInfoContainer from '../accessory-info-container';
import Cta from '../cta';
import ModalWindow from "../../components/modal-window";
import BodyControl from "../../components/body";
import {WINDOW, DOCUMENT} from '../../constants/environment'
import './styles.css';

import IconCatalogLight from './icon_catalog_light.png';
import IconCatalogDark from './icon_catalog_dark.png';
import IconLinkLight from './icon_link_light.png';
import IconLinkDark from './icon_link_dark.png';
import IconPDFLight from './icon_pdf_light.png';
import IconPDFDark from './icon_pdf_dark.png';

/**
 *  AccessoryDetailContent
 */
class AccessoryDetailContent extends Component {
  static propTypes = {
    containerId: PropTypes.string,
    containerClass: PropTypes.string,
    anchorPoint: PropTypes.string,
    anchorName: PropTypes.string,
    descriptionOfBasePrice: PropTypes.string,
    detailTitle: PropTypes.string,
    variationTitle: PropTypes.string,
    ctaButtons: PropTypes.array,
    library: PropTypes.shape({
      category: PropTypes.string,
      function: PropTypes.string,
      href1: PropTypes.string,
      external1: PropTypes.bool,
      title1: PropTypes.string,
      icon1: PropTypes.string,
      updateDate1: PropTypes.string,
      href2: PropTypes.string,
      external2: PropTypes.bool,
      title2: PropTypes.string,
      icon2: PropTypes.string,
      updateDate2: PropTypes.string,
      releaseDate: PropTypes.string,
      titleAndPreText: PropTypes.string,
      agreementText: PropTypes.array,
      linkArea: PropTypes.string,
      lowerDescription: PropTypes.string
    }),
    accessoryId: PropTypes.string,
    category: PropTypes.string,
    subCategory: PropTypes.string,
    title: PropTypes.string,
    description: PropTypes.string,
    price: PropTypes.number,
    images: PropTypes.array,
    modelName: PropTypes.string,
    bodyTypeModel: PropTypes.string,
    href: PropTypes.string,
    variations: PropTypes.arrayOf(PropTypes.shape({
      accessoryId: PropTypes.string,
      category: PropTypes.string,
      subCateogry: PropTypes.string,
      title: PropTypes.string,
      price: PropTypes.number,
      images: PropTypes.array
    })),
    info: PropTypes.array
  };
  static defaultProps = {
    containerId: null,
    containerClass: null,
    anchorPoint: null,
    anchorName: null,
    descriptionOfBasePrice: null,
    detailTitle: null,
    variationTitle: null,
    ctaButtons: null,
    library: null,
    accessoryId: null,
    category: null,
    subCategory: null,
    title: null,
    description: null,
    price: null,
    images: null,
    modelName: null,
    bodyTypeModel: null,
    href: null,
    variations: null,
    info: null
  };
  
  constructor(props) {
    super();
    this.props = props;
  }

  componentDidMount() {
    // this.openModal();
    this.embedEst();
  }
  
  render() {
    const {
      containerId,
      containerClass,
      anchorPoint,
      anchorName,
      descriptionOfBasePrice,
      detailTitle,
      variationTitle,
      ctaButtons,
      library,
      accessoryId,
      category,
      subCategory,
      title,
      description,
      price,
      images,
      modelName,
      bodyTypeModel,
      href,
      variations,
      info
    } = this.props;
    
    //
    return (
      <Wrapper
        containerId={containerId}
        containerClass={containerClass}
        anchorPoint={anchorPoint}
        anchorName={anchorName}
      >
        <div className='AccessoryDetailContent'>
          <div className='AccessoryDetailContent__container'>
            <div className='AccessoryDetailContent__container__header'>
              <div className='AccessoryDetailContent__container__header__content'>
                <div className='AccessoryDetailContent__container__header__content__text-container'>
                  {title && title !== '' ? <div className='AccessoryDetailContent__container__header__content__text-container__title'>{title}</div> : null}
                  {price ? <div className='AccessoryDetailContent__container__header__content__text-container__price'>¥{Number(price).toLocaleString()}<span className='AccessoryDetailContent__container__header__content__text-container__price__tax'>（消費税込）</span></div> : null}
                  {descriptionOfBasePrice && descriptionOfBasePrice !== '' ? <div className='AccessoryDetailContent__container__header__content__text-container__description-of-base-price' dangerouslySetInnerHTML={{__html: descriptionOfBasePrice}} /> : null}
                </div>
                {images && Array.isArray(images) && images[0] !== '' ?
                  <div className='AccessoryDetailContent__container__header__content__image-container'>
                    <div className='AccessoryDetailContent__container__header__content__image-container__wrap'>
                      <img src={images[0]} className='AccessoryDetailContent__container__header__content__image-container__wrap__image' />
                    </div>
                  </div>
                : null}
              </div>
            </div>
            <div className='AccessoryDetailContent__container__back'>
              <a href='javascript:void(0)' className='AccessoryDetailContent__container__back__link' onClick={this.onClickBack}>前に戻る</a>
            </div>
            <div className='AccessoryDetailContent__container__body'>
              <div className='AccessoryDetailContent__container__body__detail'>
                <div className='AccessoryDetailContent__container__body__detail__title'>{detailTitle}</div>
                <div className='AccessoryDetailContent__container__body__detail__description' dangerouslySetInnerHTML={{__html: convertPipeToBrTag(description)}}/>
              </div>
              {(() => {
                if((ctaButtons && Array.isArray(ctaButtons) && ctaButtons.length > 0) || (library && library.category && library.category !== '')){
                  return (
                    <div className='AccessoryDetailContent__container__body__buttons'>
                      <ul className='AccessoryDetailContent__container__body__buttons__list'>
                        {(() => {
                          if(ctaButtons && Array.isArray(ctaButtons) && ctaButtons.length > 0){
                            return (
                              ctaButtons.map((cta, index) => {
                                return(
                                  <li className='AccessoryDetailContent__container__body__buttons__list__item' key={index}>
                                    <Cta {...cta.props} />
                                  </li>
                                )
                              })
                            )
                          }
                        })()}
                        {(() => {
                          if(library && library.category && library.category !== ''){
                            let props = {};
                            let icon, linkType;
                            if(library['function'] === 'Direct-Link'){
                              switch(library.icon1){
                                case 'PDF':
                                  icon = IconPDFLight;
                                  linkType = 'Button-With-Icon';
                                  break;
                                case 'E-Book':
                                  icon = IconCatalogLight;
                                  linkType = 'Button-With-Icon';
                                  break;
                                case 'Link':
                                  icon = IconLinkLight;
                                  linkType = 'Button-With-Icon';
                                  break;
                                default:
                                  icon = null;
                                  linkType = 'Button';
                              }
                              props = {
                                ctaType: 'Free',
                                href: library.href1,
                                text: library.category,
                                targetBlank: library.external1,
                                linkType: linkType,
                                iconSrc: icon,
                                hoverIconSrc: icon,
                                color: 'Dark',
                                buttonStyle: 'Action'
                              };
                            }
                            else if(library['function'] === 'Modal-Agreement-Window'){
                              let icon = IconCatalogLight;
                              props = {
                                ctaType: 'Free',
                                href: 'javascript:void(0)',
                                text: library.category,
                                targetBlank: false,
                                linkType: 'Button-With-Icon',
                                iconSrc: icon,
                                hoverIconSrc: icon,
                                color: 'Dark',
                                buttonStyle: 'Action',
                                handleClick: this.openModal
                              };
                            }
                            
                            return (
                              <li className='AccessoryDetailContent__container__body__buttons__list__item'>
                                <Cta {...props} />
                              </li>
                            )
                          }
                        })()}
                      </ul>
                    </div>
                  )
                }
              })()}
            </div>
            {(() => {
              if(variations && Array.isArray(variations) && variations.length > 0){
                return (
                  <div className='AccessoryDetailContent__container__variations'>
                    <div className='AccessoryDetailContent__container__body__variations__title'>{variationTitle}</div>
                    <ul className='AccessoryDetailContent__container__body__variations__list'>
                      {
                        variations.map((accessory, index) => {
                          if(!accessory){
                            return false; // skip
                          }
                          let detailHref = href + (accessory.accessoryId && accessory.accessoryId !== '' ? accessory.accessoryId : '');
                          return(
                            <li className='AccessoryDetailContent__container__body__variations__list__item' key={index}>
                              <a href={detailHref} className='AccessoryDetailContent__container__body__variations__list__item__link'>
                                {accessory.images && Array.isArray(accessory.images) && accessory.images[0] !== '' ?
                                  <div className='AccessoryDetailContent__container__body__variations__list__item__image__wrap'>
                                    <img src={accessory.images[0]} className='AccessoryDetailContent__container__body__variations__list__item__image' />
                                  </div>
                                : null}
                                {accessory.title && accessory.title !== '' ? <div className='AccessoryDetailContent__container__body__variations__list__item__title'>{accessory.title}</div> : null}
                                {accessory.price ? <div className='AccessoryDetailContent__container__body__variations__list__item__price'>¥{Number(accessory.price).toLocaleString()}（消費税込）</div> : null}
                              </a>
                            </li>
                          )
                        })
                      }
                    </ul>
                  </div>
                )
              }
            })()}
            <div className='AccessoryDetailContent__container__info'>
              {(() => {
                if(info && Array.isArray(info) && info.length > 0){
                  return (
                    info.map((item, index) => {
                      return(
                        <AccessoryInfoContainer {...item.props} key={index} />
                      )
                    })
                  )
                }
              })()}
            </div>
            
          </div>
          {(() => {
            if(library) {
              return (
                <ModalWindow ref="modalWindow" type="Light" onClose={this.closeModal}>
                  <div className='AccessoryDetailContent__ModalWindow__modal-item'>
                    <div className='AccessoryDetailContent__ModalWindow__modal-item__container'>
                      <div className='AccessoryDetailContent__ModalWindow__modal-item__container__content'>
                        {(library.titleAndPreText && library.titleAndPreText !== '') ?
                          <div className="AccessoryDetailContent__ModalWindow__modal-item__container__content__header Wysiwyg" dangerouslySetInnerHTML={{__html: library.titleAndPreText}}/>
                          : null}
                        {(library.agreementText && library.agreementText instanceof Array && 1 <= library.agreementText.length) ?
                          <div className="AccessoryDetailContent__ModalWindow__modal-item__container__content__agreement">{getComponents(library.agreementText)}</div>
                          : null}
                        <dl className="AccessoryDetailContent__ModalWindow__modal-item__container__content__list-dl">
                          {(library.linkArea && library.linkArea !== '') ?
                            <dt>{library.linkArea}</dt>
                            : null}
                          <dd>
                            <ul className="AccessoryDetailContent__ModalWindow__modal-item__container__content__list-ul">
                              {(() => {
                                if(library.href1 && library.href1 !== '' && library.title1 && library.title1 !== ''){
                                  let props = {};
                                  let icon, iconHover, linkType;
                                  switch(library.icon1){
                                    case 'PDF':
                                      icon = IconPDFDark;
                                      iconHover = IconPDFLight;
                                      linkType = 'Button-With-Icon';
                                      break;
                                    case 'E-Book':
                                      icon = IconCatalogDark;
                                      iconHover = IconCatalogLight;
                                      linkType = 'Button-With-Icon';
                                      break;
                                    case 'Link':
                                      icon = IconLinkDark;
                                      iconHover = IconLinkLight;
                                      linkType = 'Button-With-Icon';
                                      break;
                                    default:
                                      icon = null;
                                      iconHover = null;
                                      linkType = 'Button';
                                  }
                                  props = {
                                    ctaType: 'Free',
                                    href: library.href1,
                                    text: library.title1,
                                    targetBlank: library.external1,
                                    linkType: linkType,
                                    iconSrc: icon,
                                    hoverIconSrc: iconHover,
                                    color: 'Dark',
                                    buttonStyle: 'Standard'
                                  };
                                  return (
                                    <li className='AccessoryDetailContent__ModalWindow__modal-item__container__content__list__item'>
                                      <Cta {...props} />
                                      {(library.updateDate1 && library.updateDate1 !== '') ? <p className="AccessoryDetailContent__ModalWindow__modal-item__container__content__list__item__update">更新日：{this.formatReleaseDate(library.updateDate1)}</p> : null}
                                    </li>
                                  )
                                }
                              })()}
                              {(() => {
                                if(library.href2 && library.href2 !== '' && library.title2 && library.title2 !== ''){
                                  let props = {};
                                  let icon, iconHover, linkType;
                                  switch(library.icon2){
                                    case 'PDF':
                                      icon = IconPDFDark;
                                      iconHover = IconPDFLight;
                                      linkType = 'Button-With-Icon';
                                      break;
                                    case 'E-Book':
                                      icon = IconCatalogDark;
                                      iconHover = IconCatalogLight;
                                      linkType = 'Button-With-Icon';
                                      break;
                                    case 'Link':
                                      icon = IconLinkDark;
                                      iconHover = IconLinkLight;
                                      linkType = 'Button-With-Icon';
                                      break;
                                    default:
                                      icon = null;
                                      iconHover = null;
                                      linkType = 'Button';
                                  }
                                  props = {
                                    ctaType: 'Free',
                                    href: library.href2,
                                    text: library.title2,
                                    targetBlank: library.external2,
                                    linkType: linkType,
                                    iconSrc: icon,
                                    hoverIconSrc: iconHover,
                                    color: 'Dark',
                                    buttonStyle: 'Standard'
                                  };
                                  return (
                                    <li className='AccessoryDetailContent__ModalWindow__modal-item__container__content__list__item'>
                                      <Cta {...props} />
                                      {(library.updateDate2 && library.updateDate2 !== '') ? <p className="AccessoryDetailContent__ModalWindow__modal-item__container__content__list__item__update">更新日：{this.formatReleaseDate(library.updateDate2)}</p> : null}
                                    </li>
                                  )
                                }
                              })()}
                            </ul>
                          </dd>
                        </dl>
                        {(library.lowerDescription && library.lowerDescription !== '') ?
                          <div className="AccessoryDetailContent__ModalWindow__modal-item__container__content__description Wysiwyg" dangerouslySetInnerHTML={{__html: library.lowerDescription}}/>
                          : null}
                      </div>
                    </div>
                  </div>
                </ModalWindow>
              )
            }
          })()}
        </div>
      </Wrapper>
    )
  }

  embedEst = () => {

    if(!WINDOW || !WINDOW.location){
      return false;
    }
    //クエリ文字列に「est=1」を含む時（カンタン見積からiframeで参照された時）
    if(WINDOW.location.search.indexOf('est=1') !== -1) {
      DOCUMENT.body.classList.add('embeded-est');

      setInterval(function () {
        var main = document.querySelector('.embeded-est');
        if (main) {
          var contentsHeight = main.getBoundingClientRect().height;
          if (0 < contentsHeight) {
            parent.postMessage({ event: 'change_module_height', value: contentsHeight }, '*'); }
        }
      }, 200);
    }
  };

  openModal = () => {
    this.refs.modalWindow.open('Light', 'Light');
    //BodyControl.openModal();
  };

  closeModal = () => {
    //BodyControl.closeModal();
  };

  onClickBack = (e) => {
    history.back();
    e.preventDefault();
  };

  // YYYYMMをYYYY年M月D日にフォーマト
  formatReleaseDate = (YYYYMMDD = null) => {
    if (!YYYYMMDD || YYYYMMDD === '') return '';
    let str = String(YYYYMMDD).substr(0, 4) + '年';
    str = str + Number(String(YYYYMMDD).substr(4, 2)) + '月';
    str = str + Number(String(YYYYMMDD).substr(6, 2)) + '日';
    return str;
  };
  
}

export default AccessoryDetailContent;



// WEBPACK FOOTER //
// ./src/containers/accessory-detail-content/index.jsx